import * as React from "react";
const SvgFiRrHouseLaptop = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-house-laptop_svg__a)">
      <path
        fill="#062147"
        d="M23 18.77V14.5c0-2.48-2.02-4.5-4.5-4.5h-7C9.02 10 7 12.02 7 14.5v4.27c-.61.55-1 1.35-1 2.23 0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3 0-.89-.39-1.68-1-2.23M9 14.5a2.5 2.5 0 0 1 2.5-2.5h7a2.5 2.5 0 0 1 2.5 2.5V18h-2.59c-.53 0-1.04.21-1.41.59l-.41.41h-3.17l-.41-.41c-.37-.37-.89-.59-1.41-.59H9.01v-3.5zM21 22H9c-.55 0-1-.45-1-1s.45-1 1-1h2.59l.41.41c.37.37.89.59 1.41.59h3.17c.53 0 1.04-.21 1.41-.59l.41-.41h2.59c.55 0 1 .45 1 1s-.45 1-1 1zM4 16c-1.1 0-2-.9-2-2V8.13c0-.93.42-1.79 1.15-2.36l4-3.13c1.09-.85 2.61-.85 3.7 0l4 3.13c.5.39.85.91 1.03 1.51.16.53.71.84 1.24.68s.83-.71.68-1.24a4.97 4.97 0 0 0-1.71-2.53l-.08-.06V1c0-.55-.45-1-1-1s-1 .45-1 1v1.56l-1.92-1.5a5 5 0 0 0-6.17 0l-4 3.13A4.97 4.97 0 0 0 0 8.13V14c0 2.21 1.79 4 4 4 .55 0 1-.45 1-1s-.45-1-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-house-laptop_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHouseLaptop;
